import { useState, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';

const DDC =
	isBrowser && typeof window !== 'undefined' && window.DDC ? window.DDC : {};
// matches both US (e.g., "94105-0011" or "94105") and Canadian  (e.g., "T2X 1V4" or "T2X1V4") postal codes
const regularExpression =
	/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/g;
const isPostalCode = new RegExp(regularExpression);

const getCookie = (name) => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	} else {
		return '';
	}
};

export const usePostalCode = () => {
	const [postalCode, setPostalCode] = useState(null);

	useEffect(() => {
		if (!isBrowser) {
			return;
		}

		const cookiePostalCode = getCookie('DDC.postalCode');
		if (
			DDC.getUrlParams().geoZip &&
			isPostalCode.test(DDC.getUrlParams().geoZip.trim())
		) {
			// if we have a valid postal code in the URL, use that
			setPostalCode(DDC.getUrlParams().geoZip.trim());
		} else if (cookiePostalCode && isPostalCode.test(cookiePostalCode)) {
			// if we have a valid postal code in the cookie, use that
			setPostalCode(cookiePostalCode);
		} else if (
			DDC.userLocation &&
			DDC.userLocation.userPostalCode &&
			isPostalCode.test(DDC.userLocation.userPostalCode)
		) {
			// if we have the user's postal code in the userLocation, we should use that
			// otherwise, use the postalCode from DDC
			setPostalCode(DDC.userLocation.userPostalCode);
		} else {
			setPostalCode('10001'); // default postal code
		}
	}, []);

	return postalCode;
};
